import API from '../api/api';

export interface IGetContent {
  id?: string;
}

export interface IContent {
  subject: string;
  content: string;
}

export interface ITranslatedContent {
  [key: string]: IContent;
}

export interface ISurveyContent {
  invitation_email: {
    translations: ITranslatedContent;
  };
}

export interface IReminderContent {
  reminder_email: {
    translations: ITranslatedContent;
  };
}

export const getSurveyContentRequest = async ({ id }: IGetContent): Promise<ISurveyContent> => {
  const { data } = await API.get(`/surveys/${id}/schedule/content/invitation/`);
  return data;
};

export const getReminderContentRequest = async ({ id }: IGetContent): Promise<IReminderContent> => {
  const { data } = await API.get(`/surveys/${id}/schedule/content/reminder/`);
  return data;
};
